export default ['api', function (api) {
    return {
        find: (basketCode) => {
            return api.get(`suggestions/${basketCode}`).
                then(response => response.data);
        }
    };
}];



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/checkout/services/suggestions.api.service.js